import { render, staticRenderFns } from "./GoodNeeds.vue?vue&type=template&id=4365cb2e&scoped=true&"
import script from "./GoodNeeds.vue?vue&type=script&lang=js&"
export * from "./GoodNeeds.vue?vue&type=script&lang=js&"
import style0 from "./GoodNeeds.vue?vue&type=style&index=0&id=4365cb2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4365cb2e",
  null
  
)

export default component.exports